import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ApiService } from '../api.service';
import { CacheService } from '../cache.service';
import { CourseService } from '../course.service';
import { CourseRegistrationsService } from '../course-registrations.service';
import { CourseRegistration } from '../course-registration.model';

@Component({
selector: 'app-course-registration',
templateUrl: './course-registration.component.html',
styleUrls: ['./course-registration.component.scss']
})
export class CourseRegistrationComponent implements OnInit {
    @Input() courseRegistration: CourseRegistration;
    // @Output() cancelAdd = new EventEmitter<boolean>();

    form;
    isAdd: boolean;
    isLoading: boolean = false;
    isLoaded: boolean = false;
    isSubmitted: boolean = false;
    isSaving: boolean = false;
    isDeleting: boolean = false;
    // isValid: boolean = false;
    isEditable: boolean = false;
    loadingError: string = '';
    loadingMsg: string = '';
    errorMessage: string = '';
    display: boolean = false;
    displayRegistrant: boolean = false;
    // display: boolean = true;

    // a2eOptions = {
    //     format: 'MM/DD/YYYY hh:mm:ss A',
    //     showClear: true,
    //     showClose: true,
    // };

    constructor(
        private apiService: ApiService,
        private courseService: CourseService,
        private courseRegistrationsService: CourseRegistrationsService,
        private fb: FormBuilder
    ) {}

    ngOnInit() {
        this.isAdd = !this.courseRegistration;
        if (this.isAdd) {
            this.courseRegistration = new CourseRegistration({});
            this.isEditable = true;
            this.isLoaded = true;
            this.display = true;
        }
        this.displayRegistrant = false;
        this.prepareForm();
    }

    prepareForm() {
        this.form = this.fb.group({
            id: [this.courseRegistration.id, []],
            firstname: [this.courseRegistration.user.firstname, []],
            lastname: [this.courseRegistration.user.lastname, []],
            status: [this.courseRegistration.status.id, []],
        });

        // this.form.valueChanges.subscribe((value) => {
        //     this.isValid = this.form.dirty && !this.form.invalid;
        // });
    }

    get() {
        if (this.isLoading) return;

        this.isEditable = false;
        this.isSaving = false;
        this.isLoading = true;
        this.loadingError = '';

        this.apiService.getCourseRegistration(this.course, this.courseRegistration).subscribe(
            (data) => {
                this.courseRegistration = new CourseRegistration(data);
                this.isLoaded = true;
                this.isLoading = false;
            },
            (error) => {
                this.isLoaded = true;
                this.isLoading = false;
                this.loadingError = error;
            }
        );
    }

    collapse() {
        if (this.isEditable) return;
        if (!this.isLoaded) this.get();
        this.display = !this.display;
    }

    collapseRegistrant() {
        if (this.isEditable) return;
        // if (!this.isLoaded) this.get();
        this.displayRegistrant = !this.displayRegistrant;
    }

    edit() {
        this.prepareForm();
        this.isEditable = true;
        this.courseRegistrationsService.isEditable = true;
    }

    cancel() {
        this.errorMessage = '';
        this.isEditable = false;
        this.courseRegistrationsService.isEditable = false;
        this.courseRegistrationsService.isAdd = false;
        this.form.reset(this.courseRegistration);
    }

    save() {
        this.isSubmitted = true;
        if ( this.form.dirty && this.form.invalid ) return;
        if ( !this.form.dirty ) return;
        if ( this.isSaving) return;
        this.isSaving = true;
        this.errorMessage = ``;

        if (!this.isAdd) {
            this.apiService
                .updateCourseRegistration(this.course, this.form.value)
                .subscribe(
                    (data) => {
                        this.courseRegistrationsService.isAdd = false;
                        this.courseRegistrationsService.isEditable = false;
                        this.courseRegistrationsService.get();
                    },
                    (error) => {
                        this.errorMessage = error;
                        this.isSaving = false;
                    }
                );
            return;
        }

        this.apiService
            .createCourseRegistration(this.course, this.form.value)
            .subscribe(
                (data) => {
                    this.courseRegistrationsService.isAdd = false;
                    this.courseRegistrationsService.isEditable = false;
                    this.courseRegistrationsService.get();
                },
                (error) => {
                    this.errorMessage = error;
                    this.isSaving = false;
                }
            );
    }

    delete() {
        if ( this.isDeleting) return;
        if ( !confirm(`Are you sure you would like to remove this Registration from this Course?`) ) return;
        this.isDeleting = true;
        this.errorMessage = ``;

        this.apiService
            .deleteCourseRegistration(this.course, this.courseRegistration)
            .subscribe(
                (data) => {
                    this.isDeleting = false;
                    this.courseRegistrationsService.get();
                },
                (error) => {
                    this.errorMessage = error;
                    this.isDeleting = false;
                }
            );
    }
    
    get course() {
        return this.courseService.course;
    }

    get user() {
        return this.courseRegistration.user;
    }

    get firstname() {
        return this.form.get('firstname');
    }

    get lastname() {
        return this.form.get('lastname');
    }

    get status() {
        return this.form.get('status');
    }

}
